import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../../Components/Common/ChartsDynamicColor";

const DeliveredOrdersChart = ({ dailyStats, dataColors }) => {
  var chartColumnDistributedColors = getChartColorsArray(dataColors);
  // dayjs.extend(window.dayjs_plugin_quarterOfYear)
  const series = [
    {
      name: "Delivered Orders",
      data: dailyStats?.map((kitchen) => ({
        x: kitchen?.kitchen_name,
        y: kitchen?.delivered_orders,
      })),
    },
  ];

  var options = {
    chart: {
      height: 350,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: chartColumnDistributedColors,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
      },
    },
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
    },
    xaxis: {
      type: "category",
      // labels: {
      //     formatter: function (val) {
      //         return "Q" + dayjs(val).quarter()
      //     }
      // },
      group: {
        style: {
          fontSize: "10px",
          fontWeight: 700,
        },
        groups: [
          { title: "2020", cols: 4 },
          { title: "2021", cols: 4 },
        ],
      },
    },
    title: {
      text: "",
      style: {
        fontWeight: 500,
      },
    },
    tooltip: {
      // x: {
      //     formatter: function (val) {
      //         return "Q" + dayjs(val).quarter() + " " + dayjs(val).format("YYYY")
      //     }
      // }
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={350}
    />
  );
};
const DeliveryTimeChart = ({ dailyStats, dataColors }) => {
  const chartColors = getChartColorsArray(dataColors);

  const categories = dailyStats.map((k) => k.kitchen_name);

  const formatSecondsToMinSec = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}m ${s}s`;
  };

  const extractRaw = (field) => dailyStats.map((k) => k[field]);

  const series = [
    {
      name: "Avg Delivery Time",
      data: extractRaw("avg_delivery_time"),
    },
    {
      name: "Min Delivery Time",
      data: extractRaw("min_delivery_time"),
    },
    {
      name: "Max Delivery Time",
      data: extractRaw("max_delivery_time"),
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
      },
    },
    colors: chartColors,
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Number(val / 60).toFixed(0);
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        rotate: -45,
      },
    },
    yaxis: {
      title: {
        text: "Delivery Time",
      },
      labels: {
        formatter: function (val) {
          const totalSeconds = Math.round(val);
          const h = Math.floor(totalSeconds / 3600);
          const m = Math.floor((totalSeconds % 3600) / 60);
          const s = totalSeconds % 60;

          if (h > 0) return `${h}h ${m}m`;
          if (m > 0) return `${m}m ${s}s`;
          return `${s}s`;
        },
      },
    },

    tooltip: {
      y: {
        formatter: function (val) {
          return formatSecondsToMinSec(val);
        },
      },
    },
    title: {
      text: "Delivery Time per Kitchen",
      style: {
        fontWeight: 500,
      },
    },
  };

  return (
    <ReactApexChart
      dir="ltr"
      className="apex-charts"
      series={series}
      options={options}
      type="bar"
      height={350}
    />
  );
};

export { DeliveryTimeChart, DeliveredOrdersChart };
